import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';
import { changeCarsImages } from './utils/functions.js';
import { initFavorites } from './utils/functions.js';
import { initCarListModals } from './utils/functions.js';
import { initEnterSubmit } from './utils/functions.js';



document.addEventListener('DOMContentLoaded', () => {
let currentFilters = {};
let currentSort = {
  type: null,
  direction: null
};
initEnterSubmit();
const filter = document.querySelector('.filter-parametres');
const choicesInstances = {};
    
const commonConfig = {
  itemSelectText: 'Выбрать',
  searchPlaceholderValue: 'Поиск...',
  noResultsText: 'Не найдено...',
  searchEnabled: false,
  shouldSort: false,
};
const selectors = [
  { selector: '.f-brand', options: { searchEnabled: true } },
  { selector: '.f-model', options: { searchEnabled: true } },
  { selector: '.f-fuel_type' },
//   { selector: '.f-engine_displacement' },
//   { selector: '.f-engine_displacementto' },
  { selector: '.f-transmission' },
//   { selector: '.f-body_type' },
//   { selector: '.f-country' },
  { selector: '.f-drive' },
//   { selector: '.f-horsepower' },
//   { selector: '.f-horsepowerto' },
  { selector: '.f-year' },
//   { selector: '.f-yearto' },
//   { selector: '.f-color' },
  // { selector: '.f-price',options: { placeholder: true , placeholderValue: 'Цена, до'} }
];




  selectors.forEach(({ selector, options = {} }) => {
    const element = document.querySelector(selector);
    if (element) {
      choicesInstances[selector] = new Choices(element, { 
        ...commonConfig, 
        ...options 
      });
    }
  });



const brandElement = document.querySelector('.f-brand');
    brandElement.addEventListener('change', debounce(async (e) => {
      const brandId = e.detail.value;
    //    choicesInstances['.f-model'].setChoices(
    //   [{ value: '', label: 'Сначала выберите бренд', disabled: true }],
    //   'value',
    //   'label',
    //   true
    // );
  await loadModelsByBrand(brandId);
    }));

  if (choicesInstances['.f-model']) {
    choicesInstances['.f-model'].setChoices(
      [{ value: '', label: 'Сначала выберите бренд', disabled: true }],
      'value',
      'label',
      true
    );
  }


  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

// const debouncedLoadCars = debounce(loadCars, 300);


async function loadModelsByBrand(brandId, modelChoicesElement = '.f-model') {
    const modelChoices = choicesInstances[modelChoicesElement];
   
    if (!modelChoices) {
        console.error('Choice instance not found for:', modelChoicesElement);
        return;
    }

    // Сбрасываем текущий выбор
    modelChoices.removeActiveItems();
    
    // Показываем состояние загрузки
    modelChoices.setChoices([{ value: '', label: 'Загрузка...', disabled: true }]);

    try {
        const response = await fetch(`/api/models?brand_id=${brandId}`);
        const models = await response.json();
        
        if (models.data && models.data.length > 0) {
            const choices = [
                { value: '', label: 'Выберите модель', selected: true, disabled: true }
            ].concat(
                models.data.map(model => ({
                    value: model.id,
                    label: model.name
                }))
            );

            modelChoices.setChoices(choices, 'value', 'label', true);
              
            //    if (baseParams.model) {
            //        console.log('starts')
            //     let modelId = parseInt(baseParams.model);
            //     modelChoices.setChoiceByValue(modelId);
         
            // }
  

        } else {
            modelChoices.setChoices([{ value: '', label: 'Нет моделей для этого бренда', disabled: true }]);
        }
    } catch (error) {
        console.error('Error loading models:', error);
        modelChoices.setChoices([{ value: '', label: 'Ошибка загрузки', disabled: true }]);
    }
}

 


  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }


const debouncedLoadCars = debounce(loadCars, 300);
async function loadCars(page = 1) {
    const loader = document.querySelector('.loader-icon');
    const pagination = document.querySelector('.pagination-container');
    const carsContainer = document.getElementById('filter-cars');
    if (loader) loader.style.display = 'flex';
  

    try {
        // 1. Создаем объект с данными запроса
        const requestData = {
            ...currentFilters,
            page: page,
          
        };



          // 2. Добавляем параметры сортировки, если они есть
        if (currentSort && currentSort.type) {
            requestData.sort = {
                type: currentSort.type,
                direction: currentSort.direction
            };
        }
        
        // 3. Отправляем запрос
        const response = await fetch('/api/cars/filter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(requestData) // Используем requestData здесь
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.total == 0) {
        carsContainer.innerHTML =   `
                <div class="alert alert-info">
                  По заданным параметрам ничего не найдено
                </div>
            `;
            pagination.innerHTML = '';
            return;
        }
      
 carsContainer.innerHTML = data.html;
  pagination.innerHTML = data.pagination_html;
carsContainer.insertAdjacentHTML('afterbegin', 
  `<div class="cars-counter">Найдено ${data.total} авто</div>`
);
changeCarsImages();
initFavorites();
initCarListModals();


    } catch (error) {
        console.error('Error loading cars:', error);
        // Можно добавить отображение ошибки пользователю
    } finally {
        if (loader) loader.style.display = 'none';

    }
}


const filterButton = document.querySelector('.show-cars');

filterButton.addEventListener('click',()=>{
        const form = document.getElementById('filter');
        const formData  = new FormData(form);
       const filters = Object.fromEntries(formData.entries());
  
         const priceFields = ['priceto', 'mileageto'];
         priceFields.forEach(field => {
    if (filters.hasOwnProperty(field) && typeof filters[field] === 'string') {
      // Удаляем ВСЕ нецифровые символы (включая -, ., , и т.д.)
      filters[field] = parseInt(filters[field].replace(/\D/g, ''));
     
      // Опционально: удаляем поле, если после очистки осталась пустая строка
      // (рекомендуется, чтобы не отправлять пустые значения в фильтр)
      if (filters[field] === '' || isNaN(filters[field])) {
         console.log(filters[field])
        delete filters[field];
      }
    }
  });
  
  currentFilters = filters;




  
        debouncedLoadCars();


});

  document.addEventListener('click', (e) => {
    if (e.target.closest('.page-link')) {
        e.preventDefault();
        const page = e.target.closest('.page-link').dataset.page;
        debouncedLoadCars(page);
        scrollToTopCarList();
    }
});


function scrollToTopCarList() {
// document.querySelector('#results').scrollIntoView({
//   behavior: 'smooth',
//   block: 'start' // 'start', 'center', 'end', 'nearest'
// });
const element = document.querySelector('.results');
const offset = element.offsetTop - 50;
window.scrollTo({
  top: offset,
  behavior: 'smooth'
});
}

const searchForm = document.querySelector('.search-form');

searchForm.addEventListener('submit',  (e) => {
      e.preventDefault();
        debounce(async () => {
  const searchInput = searchForm.querySelector('input[name="search"]');
  const pagination = document.querySelector('.pagination-container');
        const searchValue = searchInput.value.trim();
   if (!/^\d+$/.test(searchValue)) {
            document.getElementById('filter-cars').innerHTML = `
                <div class="alert alert-warning">
                    Введите корректный № автомобиля (только цифры)
                </div>
            `;
            return;
        }

        const loader = document.querySelector('.loading');
        if (loader) loader.style.display = 'flex';
        
        try {
            const response = await fetch('/api/cars/search-by-id', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: parseInt(searchValue)
                })
            });
            
            const data = await response.json();
            
            if (!response.ok) {
                throw new Error(data.message || 'Ошибка при поиске');
            }
       
            document.getElementById('filter-cars').innerHTML = data.html;
            pagination.innerHTML = '';
            
        } catch (error) {
            console.error('Search error:', error);
             pagination.innerHTML = '';
            document.getElementById('filter-cars').innerHTML = `
                <div class="alert alert-danger">
                    Ошибка: ${error.message}
                </div>
            `;
        } finally {
            if (loader) loader.style.display = 'none';
        }



   }, 300)();
});




const resetFilter = document.querySelector('.clear-filter');
resetFilter.addEventListener('click',()=> {
  const filterForm = document.getElementById('filter');
  const inputs = filterForm.querySelectorAll('input');
    inputs.forEach(input=>{
      input.value='';
    });

   Object.values(choicesInstances).forEach(choiceInstance => {
      try {
        // Сбрасываем выбор
        choiceInstance.removeActiveItems();
            document.getElementById('filter-cars').innerHTML = '';
            document.querySelector('.pagination-container').innerHTML = '';
          
        // Очищаем поиск (если есть)
        if (choiceInstance.input) {
          choiceInstance.input.value = '';
        }
       
      } catch (error) {
        console.error('Error resetting filter:', error);
      }
    });

});


 const allSelects = document.querySelectorAll('select');

    allSelects.forEach(select => {
        select.addEventListener('change', function(){

         
            if (select.name == 'brand') {
              
         console.log(select)
             const modelChoices = choicesInstances['.f-model'];
             modelChoices.removeActiveItems();
          
                  }


      const filterForm = document.getElementById('filter');
     const formData = new FormData(filterForm);
         

    currentFilters = Object.fromEntries(formData.entries());
      
  debouncedLoadCars();
        });
    });








});